import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { fullNameSchema } from '../../../definitions/sharedSchema';
import { dobUI, fullNameUI, genderUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info-title--personal'];
const INPUT_LABEL = content['vet-input-label'];

const { fullName, date, gender } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    veteranFullName: fullNameUI({ label: INPUT_LABEL }),
    veteranDateOfBirth: dobUI(INPUT_LABEL),
    veteranGender: genderUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['veteranFullName', 'veteranDateOfBirth'],
    properties: {
      veteranFullName: fullNameSchema(fullName),
      veteranDateOfBirth: date,
      veteranGender: gender,
    },
  },
};
